import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'

export type PartenerScurt = {
  id: number; name: string; phone: string | null; email: string | null
  city: string | null; vat_no: string | null; cnp: string | null; type: string | null
  warning: string | null
}

/** Alegerea partenerului: se scrie, se aleg din baza. Numele ramane scris si daca nu e
 *  in baza — facturile leaga partenerul prin text, deci un client nou nu blocheaza formularul. */
export function PartenerPicker({
  eticheta = 'Client', valoare, seteaza, alege, obligatoriu, pentruRezervare = true,
}: {
  eticheta?: string
  valoare: string
  seteaza: (v: string) => void
  alege?: (p: PartenerScurt) => void
  obligatoriu?: boolean
  pentruRezervare?: boolean
}) {
  const [termen, setTermen] = useState('')
  const [deschis, setDeschis] = useState(false)

  useEffect(() => { const t = setTimeout(() => setTermen(valoare), 250); return () => clearTimeout(t) }, [valoare])

  const { data } = useQuery({
    queryKey: ['parteneri-cauta', termen, pentruRezervare],
    queryFn: () => api.get<{ partners: PartenerScurt[] }>('/partners/search-fast',
      { q: termen, limit: 12, for_reservation: pentruRezervare }),
    enabled: termen.trim().length >= 2,
    staleTime: 60_000,
  })
  const lista = data?.partners ?? []

  return (
    <div className="relative sm:col-span-2">
      <label htmlFor="c-partener" className="text-[12.5px] text-muted mb-1 block">
        {eticheta}{obligatoriu && <span className="text-bad ml-0.5">*</span>}
      </label>
      <input id="c-partener" value={valoare} autoComplete="off"
        onChange={(e) => { seteaza(e.target.value); setDeschis(true) }}
        onFocus={() => setDeschis(true)}
        onBlur={() => setTimeout(() => setDeschis(false), 150)}
        placeholder="Scrie minim 2 litere…"
        className="h-9 w-full px-3 rounded-[var(--radius-control)] border border-line bg-surface text-[14px] focus:border-accent outline-none" />
      {deschis && lista.length > 0 && (
        <ul className="absolute z-20 mt-1 w-full max-h-72 overflow-auto bg-surface border border-line rounded-[var(--radius-card)] shadow-lg">
          {lista.map((p) => (
            <li key={p.id}>
              <button type="button"
                onMouseDown={() => { seteaza(p.name); alege?.(p); setDeschis(false) }}
                className="w-full text-left px-3 py-2 hover:bg-page">
                <span className="text-[14px]">{p.name}</span>
                {p.warning && <span className="ml-2 text-[11.5px] text-bad">{p.warning}</span>}
                <span className="block text-[12px] text-muted">
                  {[p.city, p.vat_no || p.cnp, p.phone].filter(Boolean).join(' · ') || '—'}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
